import { useQuery } from '@tanstack/react-query'
import { getCategoryById, getRule } from 'SpendControl/endpoints/spend-control'
import { extractMccs, extractMids, Parser } from 'SpendControl/parser'

export const useCategoryRule = ({ categoryId, partner }: { categoryId: string; partner: string | undefined }) => {
  const { data: category, isLoading: categoryLoading } = useQuery({
    queryKey: ['get-spend-category', categoryId],
    queryFn: () => getCategoryById(categoryId),
    enabled: Boolean(partner),
  })

  const ruleId = category?.ruleId as string | undefined

  const { data: rule, isLoading: ruleLoading } = useQuery({
    queryKey: ['get-spend-rule', ruleId],
    queryFn: () => getRule(ruleId as string),
    enabled: Boolean(ruleId),
  })

  const ast = rule?.expression ? new Parser(rule.expression).parse() : undefined

  return {
    mccs: ast ? extractMccs(ast) : [],
    mids: ast ? extractMids(ast) : [],
    expression: rule?.expression,
    isLoading: categoryLoading || (Boolean(ruleId) && ruleLoading),
  }
}
